import {compose, identity, ifElse, isNil, map, sum, values, gte} from 'ramda'

const safeParseFloat = ifElse(isNil, () => null, parseFloat)

const limitToFloat = compose(
  ifElse(gte(0), () => 0, identity),
  safeParseFloat
)

const roundToTwoDecimalPlaces = num => Math.round(num * 100) / 100

export const collectAmounts = compose(roundToTwoDecimalPlaces, sum, values, map(limitToFloat))
